// @flow
import { connect } from 'react-redux';
import zoneActions from '../../../../../../actions/zoneActions';
import Controls from '../Controls';
import type { Props } from '../Controls';

const mapDispatchToProps = {
    activate: (zoneId, duration) => zoneActions.activate([zoneId], duration),
    deactivate: (zoneId) => zoneActions.deactivate([zoneId])
};

export default connect<Props, *, _, _, _, _>(null, mapDispatchToProps)(Controls);